import {StyleSheet} from 'react-native';
import {Colors} from '../../../../../constants/Colors';

export const styles = StyleSheet.create({
  button: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 12,
    maxWidth: 100,
    textAlign: 'center',
    marginTop: 10,
    color: Colors.GrayPallete.lightgrayThree,
  },
});
